export default __webpack_public_path__ + "static/martin_bode-7268e92bbffc7caf506d56b5d8d04bb7.jpg";